import type { AgentSettingsApi } from '@env0/agent-settings-service/api';

export const getAgentDisplayName = (
  agent: Pick<AgentSettingsApi.AgentMonitoringDetails, 'name' | 'agentKey'> | null | undefined
): string => agent?.name ?? agent?.agentKey ?? '';
